import React from "react";
import Select from "react-select";

export default function Categorize({
  options,
  categorize,
  setCategorize,
  setPage,
}) {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      height: "50px",
      p: "15px 18px",
      color: "#000000",
      fontWeight: 400,
      display: "flex",
      width: "160px",
      fontsize: "14px",
      lineHeight: "20px",
      boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
      alignItems: "center",
      borderRadius: "30px",
      justifyContent: "space-between",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: " #000000",
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      fontWeight: 600,
      color: data.color,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        color: data.color,
        fontWeight: isSelected ? 600 : 400,
        backgroundColor: "white",
        fontSize: "18px",
        lineHeight: "20px",
        mixBlendMode: "normal",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
  };

  const handleTypeSelect = (e) => {
    setCategorize(e.value);

    setPage(1);
  };

  return (
    <Select
      styles={style}
      options={options}
      onChange={handleTypeSelect}
      isSearchable={false}
      placeholder="Filter Type"
      components={{
        IndicatorSeparator: () => null,
      }}
      value={options.filter(function (option) {
        return option.value === categorize;
      })}
    />
  );
}
